mutation RemoveClient($clientId: ID!) {
    removeClient(clientId: $clientId)
}
